export type SelectOption = {
  value: string | number
  label: string
}

/** Match a controlled value to an option from the list (handles string/number id mismatches). */
export function resolveSelectValue<Option extends SelectOption>(
  value: Option | string | number | null | undefined,
  options: readonly Option[] | undefined
): Option | null {
  if (value == null || value === '') return null

  if (typeof value === 'string' || typeof value === 'number') {
    return options?.find((o) => String(o.value) === String(value)) ?? null
  }

  if (value.value == null || value.value === '') return null
  const match = options?.find((o) => String(o.value) === String(value.value))
  return match ?? value
}

/** Loose equality for react-select selected/highlight state in open menus. */
export function isLooseOptionSelected<Option extends SelectOption>(
  option: Option,
  selectValue: Option | readonly Option[]
): boolean {
  const selected = Array.isArray(selectValue) ? selectValue : selectValue ? [selectValue] : []
  return selected.some((v) => String(option.value) === String(v.value))
}
